export enum DistanceUnit {
    Kilometers = 'kms',
    Meters = 'mts',
}

export enum TimeUnit {
    Hours = 'hs',
}
